<div>
	<button mat-menu-item routerLink="{{ item.url }}" [class.sdp-button-selected]="isSelectedPage(item.url)" class="sdp-dashboard-item-button">
		<div class="sdp-navigation-menu-icon-container">
			<sdp-icon [icon]="item.icon"></sdp-icon>
		</div>
		<div class="device-list-item-text sdp-navigation-name">
			{{ item.name | translate }}
			<sdp-icon class="sdp-navigation-status-icon-container" id="sdp{{ item.name }}" [icon]="item.statusIcon"></sdp-icon>
		</div>
		<span class="sdp-dashboard-item-show-child" *ngIf="isExpanded && !!item.children && isEnabled">
			<sdp-icon [icon]="rotateIcon" class="rotate rotate-start-down" [class.rotate-top]="!isShowChild"></sdp-icon>
		</span>
	</button>
	<div *ngIf="isExpanded && isShowChild">
		<div *ngFor="let child of item.children" class="sdp-dashboard-item-child">
			<button mat-menu-item routerLink="{{ child.url }}" [class.sdp-button-selected]="isSelectedPage(child.url)">
				<span class="device-list-item-text">{{ child.name | translate }}</span>
			</button>
		</div>
	</div>
</div>